/* eslint-disable promise/param-names */
import { SETTINGS_REQUEST, SETTINGS_SUCCESS, SETTINGS_ERROR } from '../actions/settings'
import { USER_REQUEST } from '../actions/user'
import axios from 'axios'
import Vue from 'vue'
import { openDB } from 'idb';
import API from "@/api";
import helper from '../../helpers/helper';

const DB_NAME = 'VOWAVE_LANG10';
const DB_VERSION = 1;

const state = { status: '', hasLoadedOnce: false, settings: null, lang: null, langv: null, lango: null, langt: DB_NAME }

// Initialize language from IndexedDB if possible, fallback to localStorage
const initLanguage = async () => {
  try {
    const db = await openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('langData')) {
          db.createObjectStore('langData');
        }
        if (!db.objectStoreNames.contains('langInfo')) {
          db.createObjectStore('langInfo');
        }
      }
    });
    
    const langInfo = await db.get('langInfo', 'current');
    if (langInfo) {
      state.lang = langInfo.code;
      state.langv = langInfo.version;
      
      // Also load the language data immediately
      const langData = await db.get('langData', langInfo.code);
      if (langData) {
        state.lango = langData;
        window.langx = langData;
      }
    } else {
      state.lang = window.localStorage.getItem('lang') || 'EN';
      state.langv = window.localStorage.getItem('langv') || null;
      
      // Try to load from localStorage as fallback
      const langCode = state.lang;
      const langData = window.localStorage.getItem('lang' + langCode);
      if (langData) {
        try {
          const parsedData = JSON.parse(langData);
          state.lango = parsedData;
          window.langx = parsedData;
        } catch (e) {
          console.error('Failed to parse language data from localStorage:', e);
        }
      }
    }
  } catch (err) {
    console.error('Failed to initialize from IndexedDB:', err);
    state.lang = window.localStorage.getItem('lang') || 'EN';
    state.langv = window.localStorage.getItem('langv') || null;
    
    // Try to load from localStorage as fallback
    const langCode = state.lang;
    const langData = window.localStorage.getItem('lang' + langCode);
    if (langData) {
      try {
        const parsedData = JSON.parse(langData);
        state.lango = parsedData;
        window.langx = parsedData;
      } catch (e) {
        console.error('Failed to parse language data from localStorage:', e);
      }
    }
  }
};

// Initialize language synchronously to avoid delay
initLanguage();
const getters = {
    isLoaded: state => !!state.hasLoadedOnce,
    settings: state => state.settings,
    lang: state => state.lang,
    langv: state => state.langv,
    lango: state => state.lango,
    langt: state => state.langt
}

// Track if a settings request is in progress
let settingsRequestInProgress = null;

const actions = {
    [SETTINGS_REQUEST]: ({ commit, dispatch, getters }, user) => {
        // If there's already a request in progress, return that promise
        if (settingsRequestInProgress) {
            return settingsRequestInProgress;
        }
        
        // Create a new promise for this request
        settingsRequestInProgress = new Promise((resolve, reject) => {
            const lang = getters.lang
            const langv = getters.langv
            
            // If we already have language data loaded, resolve immediately
            if (getters.lango) {
                window.langx = getters.lango;
                // Don't resolve the promise yet, let the API request complete
            }
            
            commit(SETTINGS_REQUEST)
            
            // Try to load settings from localStorage first
            const cachedSettings = window.localStorage.getItem('app_settings');
            if (cachedSettings) {
                try {
                    const settingsData = JSON.parse(cachedSettings);
                    commit(SETTINGS_SUCCESS, { data: settingsData });
                    bus.$emit('settingsGetted', settingsData);
                    
                    // If we don't have language data yet but have settings, try to load language
                    if (!getters.lango && settingsData.langs) {
                        const langs = settingsData.langs;
                        let d, u, l;
                        d = null;
                        u = null;
                        l = null;
                        for (let li = 0; li < langs.length; li++) {
                            d = langs[li].isDefault ? langs[li] : d
                            u = langs[li].code === lang ? langs[li] : u;
                        }
                        l = u === null ? d : u;
                        
                        // Try to load language from IndexedDB or localStorage
                        (async () => {
                            try {
                                const db = await openDB(state.langt, DB_VERSION);
                                const langData = await db.get('langData', l.code);
                                if (langData) {
                                    commit('setLango', langData);
                                    window.langx = langData;
                                    // Resolve with cached data
                                    resolve({ data: settingsData });
                                }
                            } catch (err) {
                                console.error('Error loading cached language:', err);
                            }
                        })();
                    } else if (getters.lango) {
                        // If we already have language data, resolve immediately
                        resolve({ data: settingsData });
                    }
                } catch (e) {
                    console.error('Error parsing cached settings:', e);
                }
            }
            
            // Only make one API request
            axios.defaults.headers.common['Client-Id'] = 1
            axios.defaults.baseURL = API.baseURL
            axios({ url: API.getSettings, method: 'GET' })
                .then(async resp => {
                    const langs = resp.data.langs;
                    let d, u, l;
                    d = null;
                    u = null;
                    l = null;
                    for (let li = 0; li < langs.length; li++) {
                        d = langs[li].isDefault ? langs[li] : d
                        u = langs[li].code === lang ? langs[li] : u;
                    }
                    l = u === null ? d : u;
                    // console.log('language', langv, l.version, langv !== l.version)
                    if (langv !== l.version) {
                        const rsp = await axios({ url: API.base + l.url, method: 'GET' })
                        const dt = rsp.data;
                        await commit('setLang', { lang: l, lango: dt })
                    } else {
                        try {
                            const db = await openDB(state.langt, DB_VERSION);
                            const langData = await db.get('langData', l.code);
                            if (langData) {
                                await commit('setLango', langData);
                            } else {
                                // Fallback to localStorage if not in IndexedDB
                                let lobj = JSON.parse(window.localStorage.getItem('lang'+l.code));
                                if (lobj) {
                                    await commit('setLango', lobj);
                                    // Store in IndexedDB for future use
                                    const db = await openDB(state.langt, DB_VERSION, {
                                        upgrade(db) {
                                            if (!db.objectStoreNames.contains('langData')) {
                                                db.createObjectStore('langData');
                                            }
                                            if (!db.objectStoreNames.contains('langInfo')) {
                                                db.createObjectStore('langInfo');
                                            }
                                        }
                                    });
                                    await db.put('langData', lobj, l.code);
                                } else {
                                    // If not found anywhere, fetch it
                                    const rsp = await axios({ url: API.base + l.url, method: 'GET' });
                                    const dt = rsp.data;
                                    await commit('setLang', { lang: l, lango: dt });
                                }
                            }
                        } catch (err) {
                            console.error('Error loading language from IndexedDB:', err);
                            // Fallback to localStorage
                            let lobj = JSON.parse(window.localStorage.getItem('lang'+l.code));
                            if (lobj) {
                                await commit('setLango', lobj);
                            } else {
                                // If not found in localStorage either, fetch it
                                const rsp = await axios({ url: API.base + l.url, method: 'GET' });
                                const dt = rsp.data;
                                await commit('setLang', { lang: l, lango: dt });
                            }
                        }
                    }
                    const tok = localStorage.getItem('user-token')
                    if (!!tok) {
                        axios.defaults.headers.common['Authorization'] = tok
                        axios.defaults.crossDomain = false
                        await dispatch(USER_REQUEST)
                    }
                    // Save settings to localStorage for future use
                    window.localStorage.setItem('app_settings', JSON.stringify(resp.data));
                    
                    commit(SETTINGS_SUCCESS, resp)
                    bus.$emit('baseGetted')
                    bus.$emit('settingsGetted', resp.data)
                    
                    // Only resolve if we haven't already resolved with cached data
                    if (!state.hasLoadedOnce) {
                        resolve(resp)
                    }
                })
                .catch(err => {
                    // console.log(err)
                    commit(SETTINGS_ERROR, err)
                    setTimeout(() => {
                        bus.$emit('error', {
                            title: 'Error',
                            message: 'Connection lost...'
                        })
                        // Reset the request in progress flag before retrying
                        settingsRequestInProgress = null;
                        dispatch(SETTINGS_REQUEST)
                    }, 3000)
                })
                .finally(() => {
                    // Reset the request in progress flag when done
                    settingsRequestInProgress = null;
                });
        });
        
        return settingsRequestInProgress;
    }
}

const mutations = {
    [SETTINGS_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [SETTINGS_SUCCESS]: (state, resp) => {
        state.status = 'success'
        state.settings = resp.data
        state.hasLoadedOnce = true
        // Vue.set(state, 'settings', resp.data)
    },
    [SETTINGS_ERROR]: (state) => {
        state.status = 'error'
        state.hasLoadedOnce = true
    },
    setLango: (state, o) => {
        state.lango = o
    },
    setLang: async (state, { lang, lango }) => {
        try {
            // Store language data in IndexedDB
            const db = await openDB(state.langt, DB_VERSION, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains('langData')) {
                        db.createObjectStore('langData');
                    }
                    if (!db.objectStoreNames.contains('langInfo')) {
                        db.createObjectStore('langInfo');
                    }
                }
            });
            
            // Store the language data
            await db.put('langData', lango, lang.code);
            
            // Store current language info
            await db.put('langInfo', {
                code: lang.code,
                version: lang.version,
                timestamp: Date.now()
            }, 'current');
            
            // Update state
            state.lango = lango;
            state.lang = lang.code;
            state.langv = lang.version;
            
            // Keep localStorage as fallback
            window.localStorage.setItem('lang', lang.code);
            window.localStorage.setItem('langv', lang.version);
            
            // Remove the old localStorage data to save space
            window.localStorage.removeItem('lang'+state.lang);
        } catch (e) {
            console.error('Error storing language in IndexedDB:', e);
            
            // Fallback to localStorage if IndexedDB fails
            state.lango = lango;
            state.lang = lang.code;
            state.langv = lang.version;
            window.localStorage.setItem('lang'+state.lang, JSON.stringify(lango));
            window.localStorage.setItem('lang', lang.code);
            window.localStorage.setItem('langv', lang.version);
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}
